import React from "react";
import { Reveal } from "@/components/Reveal";
import { useI18n } from "@/i18n";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export function Faq() {
  const { t } = useI18n();
  const f = t.faq;
  return (
    <section id="faq" className="bg-background py-24 md:py-32">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <Reveal className="text-center">
          <p className="overline text-accent">{f.overline}</p>
          <h2 className="mt-4 font-serif text-5xl md:text-6xl tracking-tight">{f.title}</h2>
        </Reveal>
        <Reveal delay={0.1} className="mt-14">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {f.items.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-border">
                <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left hover:no-underline py-6">
                  <h3 className="font-serif text-xl md:text-2xl tracking-tight font-normal m-0">{item.q}</h3>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
